export function normalizeBehaviorEventHandlers(normalizedBehaviors) {
	const normalizedBehaviorEventHandlers = [];
	const {length: numberOfBehaviors} = normalizedBehaviors;
	for (let i = 0; i < numberOfBehaviors; i++) {
		const {
			behavior: {eventHandlers = [], options = {}}
		} = normalizedBehaviors[i];
		const {length: numberOfEvents} = eventHandlers;
		for (let k = 0; k < numberOfEvents; k++)
			normalizedBehaviorEventHandlers.push({...eventHandlers[k], behaviorOptions: {...options}});
	}

	return normalizedBehaviorEventHandlers;
}
